import { strftimeToLuxonFormat } from '@calendly/datetime'

/**
 * Maps Luxon format tokens from `strftimeToLuxonFormat` to Moment.js format tokens.
 * Order is longest-first so `yyyy` wins over `yy`, `dddd`/`MMMM` are not split, etc.
 */
const LUXON_TO_MOMENT = [
  ['yyyy', 'YYYY'],
  ['cccc', 'dddd'],
  ['ZZZZ', 'z'],
  ['MMMM', 'MMMM'],
  ['MMM', 'MMM'],
  ['MM', 'MM'],
  ['ccc', 'ddd'],
  ['ZZ', 'Z'],
  ['HH', 'HH'],
  ['mm', 'mm'],
  ['ss', 'ss'],
  ['dd', 'DD'],
  ['yy', 'YY'],
  ['d', 'D'],
  ['h', 'h'],
  ['a', 'a'],
]

/**
 * Converts a Luxon format string (single-quoted literals) to a Moment format string ([] literals).
 */
function luxonFormatStringToMomentFormatString(luxonFormat) {
  if (luxonFormat == null || luxonFormat === '') return ''

  let out = ''
  let i = 0
  while (i < luxonFormat.length) {
    if (luxonFormat[i] === "'") {
      i += 1
      let lit = ''
      let inLiteral = true
      while (inLiteral && i < luxonFormat.length) {
        if (luxonFormat[i] === "'" && luxonFormat[i + 1] === "'") {
          lit += "'"
          i += 2
        } else if (luxonFormat[i] === "'") {
          i += 1
          inLiteral = false
        } else {
          lit += luxonFormat[i]
          i += 1
        }
      }
      const escaped = lit.replace(/\]/g, ']]').replace(/\[/g, '[[')
      out += `[${escaped}]`
    } else {
      let matched = false
      for (let t = 0; t < LUXON_TO_MOMENT.length; t += 1) {
        const [luxonToken, momentToken] = LUXON_TO_MOMENT[t]
        if (luxonFormat.startsWith(luxonToken, i)) {
          out += momentToken
          i += luxonToken.length
          matched = true
          break
        }
      }
      if (!matched) {
        out += luxonFormat[i]
        i += 1
      }
    }
  }
  return out
}

/**
 * Converts strftime format strings to Moment.js format tokens via `@calendly/datetime`'s
 * canonical `strftimeToLuxonFormat`, then maps Luxon tokens to Moment.
 *
 * @param {string} strftimeFormat - e.g. "%A, %B %-d, %Y"
 * @returns {string} Moment format string
 */
export function strftimeToMomentFormat(strftimeFormat) {
  const luxonFormat = strftimeToLuxonFormat(strftimeFormat)
  return luxonFormatStringToMomentFormatString(luxonFormat)
}
